
import React ,{ useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getOnePartner } from '../redux/apiCalls/accidentApiCall';
import { useParams } from 'react-router-dom';
function InfosPartner() {
  const dispatch = useDispatch();
  const [userData, setUserData] = useState({
    name: "",
    email: "",
    address: "",
    city: "",
    phoneNumber:"",
    description: "",
    iban: "",
    accountInfo: "",
    username: "",
    profilePhoto: "",
  });
  const { id } = useParams();
  const {partner, getLoading} = useSelector((state) => state.accident);
  useEffect(() => {
    if (id) {
      dispatch(getOnePartner(id));
    }
  }, [dispatch, id]);

  useEffect(() => {
    if (partner !== null) {
      
      setUserData({
        name: partner?.user.name || "",
        email: partner?.user.email || "",
        address: partner?.user.address || "",
        city: partner?.user.city || "",
        phoneNumber: partner?.user.phoneNumber || "",
        description: partner?.user.description || "",
        iban: partner?.user.iban || "",
        accountInfo: partner?.user.accountInfo || "",
        username: partner?.user.username || "",
        profilePhoto: partner?.user.profilePhoto?.url || ""
      });
    }
  }, [partner]);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserData((prev) => ({ ...prev, [name]: value }));
  };
  
  if(!partner){
    return <div>loading...</div>
  }


  return (
    <div className='flex flex-col w-[100%] h-screen overflow-y-auto hidden-scrollbar'>
        <div className="bg-gray-100 min-h-screen p-8">
  <form className=" p-6 rounded-lg flex flex-col">
    <div className="">
      <div className="flex w-[100%] items-center pb-[10px]">
        <label className="font-[700] w-[25%]">Name</label>
        <input
          type="text"
          value={userData?.name}
          onChange={handleChange}
          readOnly
          className="w-full border border-gray-300 bg-[#c8e8ef] rounded-[18px] pt-[5px] pl-[10px] pr-[10px] pb-[5px] focus:outline-none"
        />
      </div>
      <div className="flex w-[100%] items-center pt-[10px] pb-[10px]">
        <label className="font-[700] w-[25%]">Adresse</label>
        <input
          type="text"
          value={userData?.address}
          onChange={handleChange}
          readOnly
          className="w-full border border-gray-300 bg-[#c8e8ef] rounded-[18px] pt-[5px] pl-[10px] pr-[10px] pb-[5px] focus:outline-none"
        />
      </div>
      <div className="flex w-[100%] items-center pt-[10px] pb-[10px]">
        <label className="font-[700] w-[25%]">Ort:</label>
        <input
          type="text"
          value={userData?.city}
          onChange={handleChange}
          readOnly
          className="w-full border border-gray-300 bg-[#c8e8ef] rounded-[18px] pt-[5px] pl-[10px] pr-[10px] pb-[5px] focus:outline-none placeholder:text-center placeholder:font-[500]"
          placeholder='Bauteil'
        />
      </div>
      <div className="flex w-[100%] items-center pt-[10px] pb-[10px]">
        <label className="font-[700] w-[25%]">IBAN</label>
        <input
          type="text"
          value={userData?.iban}
          onChange={handleChange}
          readOnly
          className="w-full border border-gray-300 bg-[#c8e8ef] rounded-[18px] pt-[5px] pl-[10px] pr-[10px] pb-[5px] focus:outline-none placeholder:text-center placeholder:font-[500]"
          placeholder='Bauteil'
        />
      </div>
      <div className="flex w-[100%] items-center pt-[10px] pb-[10px]">
        <label className="font-[700] w-[25%]">Bankdaten</label>
        <input
          type="text"
          value={userData?.accountInfo}
          onChange={handleChange}
          readOnly
          className="w-full border border-gray-300 bg-[#c8e8ef] rounded-[18px] pt-[5px] pl-[10px] pr-[10px] pb-[5px] focus:outline-none placeholder:text-center placeholder:font-[500]"
          placeholder='Nur Ort'
        />
      </div>
      <div className="flex w-[100%] items-center pt-[10px] pb-[10px]">
        <label className="font-[700] w-[25%]">Benutzername</label>
        <input
          type="text"
          value={userData?.username}
          onChange={handleChange}
          readOnly
          className="w-full border border-gray-300 bg-[#c8e8ef] rounded-[18px] pt-[5px] pl-[10px] pr-[10px] pb-[5px] focus:outline-none placeholder:text-center placeholder:font-[500]"
          placeholder='geparkt, vorfahrt etc.'
        />
      </div>
      <div className="flex w-[100%] items-center pt-[10px] pb-[10px]">
        <label className="font-[700] w-[25%]">Passwort</label>
        <input
          type="text"
          readOnly
          className="w-full border border-gray-300 bg-[#c8e8ef] rounded-[18px] pt-[5px] pl-[10px] pr-[10px] pb-[5px] focus:outline-none placeholder:text-center placeholder:font-[500]"
          placeholder=''
        />
      </div>
      <div className="flex w-[100%] items-center pt-[10px] pb-[10px]">
        <label className="font-[700] w-[25%]">Telefonnummer</label>
        <input
          type="text"
          value={userData?.phoneNumber}
          onChange={handleChange}
          readOnly
          className="w-full border border-gray-300 bg-[#c8e8ef] rounded-[18px] pt-[5px] pl-[10px] pr-[10px] pb-[5px] focus:outline-none placeholder:text-center placeholder:font-[500]"
          placeholder='PLZ, Screenshot Maps O.Ä.'
        />
      </div>
      <div className="flex w-[100%] items-center pt-[10px] pb-[10px]">
        <label className="font-[700] w-[25%]">Email-Adresse</label>
        <input
          type="text"
          value={userData?.email}
          onChange={handleChange}
          readOnly
          className="w-full border border-gray-300 bg-[#c8e8ef] rounded-[18px] pt-[5px] pl-[10px] pr-[10px] pb-[5px] focus:outline-none placeholder:text-center placeholder:font-[500]"
          placeholder='Inhaber und IBAN'
        />
      </div>
      {userData?.profilePhoto && (
            <div className="flex justify-center pb-[10px]">
              <img
                src={userData.profilePhoto}
                alt="User Profile"
                className="w-32 h-32 border border-gray-300"
              />
            </div>
          )}
    </div>

    <div className="flex pb-[10px]">
      <label className="font-[700] w-[25%]">
      Bemerkungen
      </label>
      <textarea
                value={userData?.description}
                onChange={handleChange}
                readOnly
        className="w-full resize-none rounded-[19px] p-2 focus:outline-none border border-gray-300 bg-[#c8e8ef]"
        rows="3"
      ></textarea>
    </div>
  </form>
</div>
    </div>
  )
}

export default InfosPartner
